// extracted by mini-css-extract-plugin
export default {"container":"dropdown-option_container__VgYG6","label":"dropdown-option_label__fQQ8n","center":"dropdown-option_center__g1oSu","count":"dropdown-option_count__JjOlH"};